import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export const PRIVACY_REVISION_NOTICE_STORAGE_KEY = 'resume_privacy_revision_notice_20260601_dismissed';

export const isPrivacyRevisionNoticeActive = (date = new Date()) => {
  const noticeEndAt = new Date(2026, 5, 1, 0, 0, 0, 0);
  return date < noticeEndAt;
};

const PrivacyRevisionNotice = ({ className = '' }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!isPrivacyRevisionNoticeActive()) return;

    try {
      setIsVisible(localStorage.getItem(PRIVACY_REVISION_NOTICE_STORAGE_KEY) !== 'true');
    } catch {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);

    try {
      localStorage.setItem(PRIVACY_REVISION_NOTICE_STORAGE_KEY, 'true');
    } catch {
      // Storage can be unavailable in private or restricted browser contexts.
    }
  };

  if (!isVisible) return null;

  return (
    <div
      className={`w-full max-w-[1124px] overflow-hidden rounded-xl border border-[#BFE9E4] bg-[#F4FBFA] text-[#111827] shadow-[0_4px_14px_rgba(15,23,42,0.05)] ${className}`}
      role="region"
      aria-label="개인정보 처리방침 개정 공지"
    >
      <div className="flex min-h-[44px] items-center gap-2 px-3 py-2 text-[11px] leading-5 sm:text-[12px] md:min-h-[48px] md:gap-3 md:px-4 md:text-[14px]">
        <span className="inline-flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-[#16C1B1] text-[12px] font-[700] text-white">
          !
        </span>
        <p className="min-w-0 flex-1 truncate">
          <span className="font-[700]">개인정보 처리방침이 개정됩니다.</span>
          <span className="ml-1 text-[#4B5563]">주요 변경사항을 확인해 주세요.</span>
        </p>
        <Link
          to="/resume/privacy-policy/revision"
          className="flex-shrink-0 rounded-lg border border-[#16C1B1] bg-white px-2 py-1 text-[11px] font-[700] text-[#0F8F84] hover:bg-[#E8F8F6] md:px-3 md:text-[13px]"
          aria-label="개정사항 보기"
        >
          <span className="md:hidden">보기</span>
          <span className="hidden md:inline">개정사항 보기</span>
        </Link>
        <button
          type="button"
          onClick={handleDismiss}
          className="inline-flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full text-[12px] font-[700] text-[#6B7280] hover:bg-white"
          aria-label="개인정보 처리방침 개정 공지 닫기"
        >
          X
        </button>
      </div>
    </div>
  );
};

export default PrivacyRevisionNotice;
